<template>
    <section class="club-user main-body">
        <h3 class="subheading">User Status</h3>
        <section class="section-container overflow-hidden">
            <v-layout>
                <div class="flex sm12 md5">
                    <p><strong>Created:</strong> {{ userFormFields.attributes.createdAt | moment('DD/MM/YYYY (HH:mm:ss)') }}</p>
                    <p><strong>Modified:</strong> {{ userFormFields.attributes.lastModifiedAt | moment('DD/MM/YYYY (HH:mm:ss)') }}</p>
                    <p><strong>Status:</strong> {{ userFormFields.attributes.status.replace(/_/g, ' ') }}</p>
                    <div v-if="userFormFields.attributes.status === 'UNCONFIRMED'">
                        User has been created but not confirmed.
                        <v-btn
                            class="v-btn__content"
                            color="#c0c0c0"
                            dark
                            type="button"
                            depressed
                            @click="confirmSignup()"
                        >
                            Confirm User
                        </v-btn>
                    </div>
                    <div v-if="userFormFields.attributes.status === 'CONFIRMED'">User has been confirmed.</div>
                    <div v-if="userFormFields.attributes.status === 'ARCHIVED'">User is no longer active..</div>
                    <div v-if="userFormFields.attributes.status === 'COMPROMISED'">User is disabled due to a potential security threat.
                    </div>
                    <div v-if="userFormFields.attributes.status === 'UNKNOWN'">User status is not known</div>
                    <div v-if="userFormFields.attributes.status === 'RESET_REQUIRED'">User is confirmed, but the user must request a code
                        and reset his or her password before he or she can sign in.</div>
                    <div v-if="userFormFields.attributes.status === 'FORCE_CHANGE_PASSWORD'">The user is confirmed and the user can sign
                        in using a temporary password, but on first sign-in, the user must change his or her password to a
                        new value before doing anything else.
                    </div>
                </div>
                <div class="flex sm12 md5">
                    <v-flex align-left>
                        <v-layout>
                            <template v-if="userFormFields.attributes.enabled === true">
                                <div class="flex sm12 md5">
                                    User currently enabled
                                </div>
                                <div class="flex sm12 md5">
                                    <v-btn
                                        class="save-status"
                                        color="#FFA500"
                                        dark
                                        type="button"
                                        depressed
                                        @click="disableUser()"
                                    >
                                        Disable User
                                    </v-btn>
                                </div>
                            </template>
                            <template v-else-if="userFormFields.attributes.enabled === false">
                                <div class="flex sm12 md5">
                                    User currently disabled
                                </div>
                                <div class="flex sm12 md5">
                                    <v-btn
                                        class="save-status"
                                        color="#5EA77E"
                                        dark
                                        type="button"
                                        depressed
                                        @click="enableUser()"
                                    >
                                        Enable User
                                    </v-btn>
                                    <confirmation-modal
                                        @confirmed="deleteUser()"
                                        title="Delete Club User"
                                        text="This action is permanent, are you sure you want to delete this club user?"
                                    >
                                        <v-btn
                                            class="save-status"
                                            color="#FF0000"
                                            dark
                                            type="button"
                                            depressed
                                        >
                                            Delete User
                                        </v-btn>
                                    </confirmation-modal>
                                </div>
                            </template>

                        </v-layout>
                        <v-layout v-if="userFormFields.attributes.status === 'CONFIRMED'">
                            <template>
                                <div class="flex sm12 md5">
                                    Set a temporary password for the user
                                </div>
                                <div class="flex sm12 md5">
                                    <confirmation-modal
                                        @confirmed="setPassword($event)"
                                        title="Set Temporary Password"
                                        text="Setting a temporary password on behalf of the user is not advised except in specific cases. This should only be done at the client's own risk."
                                        :hasInput="true"
                                        inputType="password"
                                        cancelButton="cancel"
                                        confirmButton="Set Password"
                                    >
                                        <v-btn
                                            class="save-status"
                                            color="accent"
                                            dark
                                            type="button"
                                            depressed
                                        >
                                            Set Password
                                        </v-btn>
                                    </confirmation-modal>
                                </div>
                            </template>
                        </v-layout>
                        <!-- <v-layout v-if="userFormFields.attributes.status === 'CONFIRMED'">
                            <template>
                                <div class="flex sm12 md5">
                                    Reset the user's password
                                </div>
                                <div class="flex sm12 md5">
                                    <v-btn
                                        class="save-status"
                                        color="accent"
                                        dark
                                        type="button"
                                        depressed
                                        @click="resetPassword()"
                                    >
                                        Reset Password
                                    </v-btn>
                                </div>
                            </template>
                        </v-layout> -->

                    </v-flex>
                </div>
            </v-layout>
        </section>
        <h3 class="subheading">User Info</h3>
        <section class="section-container overflow-hidden">
            <div class="container__wrapper">
                <div class="left">
                    <label
                    class="label"
                    for="sub"
                    >
                        Sub
                    </label>
                    <v-text-field
                        readonly
                        disabled
                        v-model="userFormFields.attributes.sub"
                        variant="solo"
                        flat
                    />
                </div>
                <div class="right">
                    <label
                        class="label"
                        for="email"
                    >
                        Email
                    </label>
                    <v-text-field
                        v-model="userFormFields.attributes.email"
                        placeholder="Email"
                        type="email"
                        variant="solo"
                        flat
                    />
                </div>
                
            </div>
            <div class="container__wrapper">
                <div class="left">
                    <label
                        class="label"
                        for="given_name"
                    >
                        First Name
                    </label>
                  
                    <v-text-field
                        v-model="userFormFields.attributes.given_name"
                        type="text"
                        placeholder="First Name"
                        variant="solo"
                        flat
                    />
                </div>
                <div class="right">
                    <label
                        class="label"
                        for="family_name"
                    >
                        Last Name
                    </label>
                    <v-text-field
                        v-model="userFormFields.attributes.family_name"
                        type="text"
                        placeholder="Last Name"
                        variant="solo"
                        flat
                    />
                </div>
            </div>
        </section>
        <sticky-footer
            :errorMessage="errorMessage"
            :status="saveStatus"
            @buttonClicked="updateUserDetails()"
            :allowPreview="false"
        />
    </section>
</template>

<script>
import axios from "axios"
import StickyFooter from "../../components/Library/StickyFooter";
import ConfirmationModal from "@/components/Library/GlobalModals/ConfirmationModal";

export default {
    name: "ClubUserForm",
    components: {
        StickyFooter,
        ConfirmationModal
    },
    data: () => ({
        userId: null,
        errorMessage: "",
        userFormFields: {},
        visible: "",
        valid: false,
        saveError: "",
        saveStatus: "needsSaving",
        api: `${process.env.VUE_APP_CLUBSAPI}`,

    }),
    mounted() {
        this.getSingleUserDetails(),
        this.userFormFields = {
            attributes: {
                given_name: null,
                family_name: null,
                email: null,
                sub: null,
                createdAt: null,
                lastModifiedAt: null,
                enabled: null,
                status: null
            }
        }
    },
    methods: {
        toCamelCase(str) {
            return str.replace(/_./g, match => match.charAt(1).toUpperCase());
        },
        getSingleUserDetails() {
            this.$store.commit("startLoading");
            this.userId = this.$route.params.id
            this.$getCurrentUserJwToken().subscribe((jwt) => {
                axios({
                    method: "GET",
                    url: `${this.api}/users/${this.userId}`,
                    headers: { Authorization: jwt },
                })
                .then((response) => {
                    console.log(response)
                    this.userFormFields = response.data.data
                    this.$store.commit("completeLoading");
                })
                
                .catch(e => {
                    console.log("Unable to load teams:", e);
                })
            })
        },  
        disableUser() {
            console.log("disable user")
            this.$getCurrentUserJwToken().subscribe((jwt) => {
                axios({
                    method: "PATCH",
                    url: `${this.api}/users/${this.userId}`,
                    headers: { "Authorization": jwt },
                    data: {
                        data: {
                            id: this.userId,
                            type: "club-page-user",
                            attributes: {
                                disable: "true",
                            }
                        }
                    }
                })
                .then(response => {
                    console.log("user disabled", response)
                    this.getSingleUserDetails()
                })
                .catch(e => {
                    console.error("Problem disabling user", e);
                    this.errorMessage = "Problem disabling user";
                });
            })
        },
        enableUser() {
            console.log("enable user")
            this.$getCurrentUserJwToken().subscribe((jwt) => {
                axios({
                    method: "PATCH",
                    url: `${this.api}/users/${this.userId}`,
                    headers: { "Authorization": jwt },
                    data: {
                        data: {
                            id: this.userId,
                            type: "club-page-user",
                            attributes: {
                                enable: "true"
                            }
                        }
                    }
                })
                .then(response => {
                    console.log("user enabled", response)
                    this.getSingleUserDetails()
                })
                .catch(e => {
                    console.error("Problem enabling user", e);
                    this.errorMessage = "Problem enabling user";
                });
            })
        },
        deleteUser() {
            console.log("delete user")
            this.$getCurrentUserJwToken().subscribe((jwt) => {
                axios({
                    method: "DELETE",
                    url: `${this.api}/users/${this.userId}`,
                    headers: { "Authorization": jwt },
                })
                .then(response => {
                    console.log("user deleted", response)
                    this.$router.push("/club-users")
                })
                .catch(e => {
                    console.error("Problem deleting user", e);
                    this.errorMessage = "Problem deleting user";
                });
            })
        },
        resetPassword() {
            console.log("reset password for user")
            this.$getCurrentUserJwToken().subscribe((jwt) => {
                axios({
                    method: "PATCH",
                    url: `${this.api}/users/${this.userId}`,
                    headers: { "Authorization": jwt },
                    data: {
                        data: {
                            id: this.userId,
                            type: "club-page-user",
                            attributes: {
                                "reset_password": "true"
                            }
                        }
                    }
                })
                    .then(response => {
                        console.log("user password reset", response)
                        this.getSingleUserDetails()
                    })
                    .catch(e => {
                        console.error("Problem resetting password for user", e);
                        console.error("Problem resetting password for user", e.response);

                        if (e.response.data.errors && e.response.data.errors.length) {
                            this.errorMessage = e.response.data.errors[0].detail
                        } else {
                            this.errorMessage = "Problem resetting user password";
                        }
                    });
            })
        },
        setPassword(password) {
            console.log("set pass", password)
            this.errorMessage = ""
            this.$getCurrentUserJwToken().subscribe((jwt) => {
                axios({
                    method: "PATCH",
                    url: `${this.api}/users/${this.userId}`,
                    headers: { "Authorization": jwt },
                    data: {
                        data: {
                            id: this.userId,
                            type: "club-page-user",
                            attributes: {
                                set_password: "true",
                                password,
                            }
                        }
                    }
                })
                    .then(response => {
                        this.getSingleUserDetails()
                    })
                    .catch(e => {
                        console.error("Problem setting password user", e);
                        if (
                            e.response &&
                            e.response.data.errors &&
                            e.response.data.errors[0] &&
                            e.response.data.errors[0].detail
                        ) {
                            this.errorMessage = e.response.data.errors[0].detail;
                        } else {
                            this.errorMessage = "Problem setting password";
                        }
                    });
            })
        },
        confirmSignup() {
            this.$getCurrentUserJwToken().subscribe((jwt) => {
                axios({
                    method: "PATCH",
                    url: `${this.api}/users/${this.userId}`,
                    headers: { "Authorization": jwt },
                    data: {
                        data: {
                            id: this.userId,
                            type: "club-page-user",
                            attributes: {
                                confirm_signup: "true"
                            }
                        }
                    }
                })
                    .then(response => {
                        this.getSingleUserDetails()
                    })
                    .catch(e => {
                        console.error("Problem confirming user", e);
                        this.errorMessage = "Problem confirming user";
                    });
            })
        },  

        updateUserDetails() {
            this.saveStatus = "saving";
            this.errorMessage = "";
            this.$getCurrentUserJwToken().subscribe((jwt) => {
                axios({
                    method: "PATCH",
                    url: `${this.api}/users/${this.userId}`,
                    headers: { Authorization: jwt },
                    data: {
                        data: {
                            id: this.userId,
                            type: "club-page-user",
                            attributes: {
                                email: this.userFormFields.attributes.email,
                                given_name: this.userFormFields.attributes.given_name,
                                family_name: this.userFormFields.attributes.family_name
                            } 
                        },
                    }
                })
                .then((response) => {
                    this.saveStatus = "saved";
                }).catch((err) => {
                    this.errorMessage = "Certain entries are invalid or required";
                    this.saveStatus = "needsSaving";
                    console.error("Problem saving club users", this.errorMessage, err);
                })
            });
        },
        
    }
}
</script>

<style lang='scss'>
.subheading {
    margin: 35px 0 20px;
    padding: 0;
    color: #67247C;
    font-size: 16px;
    font-weight: 400;
    line-height: 1;
    text-transform: capitalize;

    &__closed {
      border-bottom: 1px solid $lightgrey;
      padding-bottom: 12px;
    }
    &:hover {
      cursor: pointer;
    }

    &__label {
      position: relative;
      top: -2px;
      margin: 0 0 0 8px;
      padding: 4px 8px;
      color: #67247C;
      font-size: 12px;
      font-weight: 400;
      background-color: #E6E8F1;
      border-radius: 4px;
    }
}

.container__wrapper {
    display: flex;
    .left {
        width: 50%;
    }

    .middle {
        width: 100%;
        flex-grow: 1;
    }

    .right {
        margin-left: 20px;
        width: 50%;
    }
}

.club-user {
    .half {
        width: 50%;
    }

    .v-select {
        &.v-text-field {
            input {
                border: none !important
            }
        } 
    } 

    .theme--light {
        &.v-text-field--solo {
            .v-input__control {
                .v-input__slot {
                    border: 1px solid #ccc;
                }
            }
        }
    } 
    .v-text-field {
        input {
            padding: 24px 5px;
            max-width: 100%;
            border: 1px solid #ccc;
            border-radius: 4px;
        }

        .v-input__control {
            .v-input__slot {
                &:before {
                    border-style: none;
                }
            }
        }
    }
}

</style>